const instructionsDataInitial = [
  {
    id: "toast",
    name: "Toast coconut",
    steps: [
      { text: "Preheat oven to _400°F_" },
      { 
        text: "Spread the #shredded coconut# onto a baking sheet. Place in oven for 3-5 minutes, until coconut is a light golden brown color.",
        note: "Make sure to stay in the kitchen watch the coconut, as it burns really easily. Alternately, you can toast the coconut in a pan on the stove top." 
      }
    ]
  },
  {
    id: "process-shape-freeze",
    name: "Process & shape cookies",
    steps: [
      { text: "Add #dates# and *toasted coconut* into the bowl of a food processor. Pulse until mixture is combined and starts to form a ball of dough." },
      { text: "For each cookie: scoop about 1 Tbsp of dough, shape into a round cookie, then place on a baking sheet lined with parchment paper." },
      { text: "Using a straw or chopstick punch a hole in the middle of each cookie. Move the straw or chopstick around a bit to make the hole wider, if needed. At this point you’ll likely need to reshape the cookie a bit." },
      { 
        text: "Place baking sheet in the freezer for 10 minutes so the cookies harden a bit.",
        timer: 10
      }
    ]
  },
  {
    id: "finish",
    name: "Add chocolate",
    steps: [
      { text: "When the cookies are almsot done hardening in the freezer, add #chocolate# and #coconut oil# to a shallow microwave-safe bowl, and melt in 20-30 second increments until the chocolate is melted enough to drizzle" },
      { text: "Grab cookies from the freezer and dip each one in the chocolate to coat the bottom. Place cookies on the parchment and use remaining chocolate to drizzle over top the cookies." },
      { 
        text: "Transfer cookies back into the freezer for 10-15 minutes to let the chocolate harden. Once they’ve hardened you’ll be able to easily remove the cookies from the parchment paper.",
        timer: 15,
        note: "If you want to enjoy right away, let them sit out on the counter for a few minutes. For enjoying later, store in a sealed container in the fridge for up to one week."
      }
    ]
  }
]

function importAll(r) {
  return r.keys().map(r);
}

// this is a different approach where we only import media from the top level
// folder (media/instructions), which is done by setting 'false' instead of 'true'
// since the file name already has the sectionId in it, we don't need to put the files
// into separate folders
const allMedia = importAll(require.context('./media/instructions', false, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
  const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
  if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
  acc[sectionId].push(path); // Add path to array
  return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
  // if there's an array of media for the given section
  if (mediaBySection[section.id]) {
      // add media array
      return { ...section, media: mediaBySection[section.id] };
  } else {
      return section;
  }
})